import { create } from "zustand"
import { persist } from "zustand/middleware"

export const INBOX_SECTIONS = {
	agent: "agent",
	views: "views",
} as const

export type InboxSectionId =
	(typeof INBOX_SECTIONS)[keyof typeof INBOX_SECTIONS]

interface InboxNavState {
	// Sections default to open, so only the ones the user closed are stored.
	collapsedSections: string[]
	toggleSection: (sectionId: InboxSectionId) => void
	openSection: (sectionId: InboxSectionId) => void
}

export const useInboxNavStore = create<InboxNavState>()(
	persist(
		(set) => ({
			collapsedSections: [],
			toggleSection: (sectionId) =>
				set((state) => ({
					collapsedSections: state.collapsedSections.includes(sectionId)
						? state.collapsedSections.filter((id) => id !== sectionId)
						: [...state.collapsedSections, sectionId],
				})),
			openSection: (sectionId) =>
				set((state) => ({
					collapsedSections: state.collapsedSections.filter(
						(id) => id !== sectionId,
					),
				})),
		}),
		{ name: "inbox-nav-state" },
	),
)

export const useIsInboxSectionOpen = (sectionId: InboxSectionId) =>
	useInboxNavStore((s) => !s.collapsedSections.includes(sectionId))
